export enum Channel {
  APP = 'app',
  EMAIL = 'email',
  FACEBOOK_MESSENGER = 'fb',
  WEB = 'web',
  WHATSAPP = 'wa',
}

export const channelFriendlyName = (channel: string) => {
  let n = '';

  switch (channel) {
    case 'app':
      n = 'APP';
      break;
    case 'email':
      n = 'Correo';
      break;
    case 'fb':
      n = 'Messenger';
      break;
    case 'web':
      n = 'WEB';
      break;
    case 'wa':
      n = 'Whatsapp';
      break;
    case 'SDK':
      n = 'SDK';
      break;
    default:
      n = 'Desconocido';
  }

  return n;
};
